import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';

import NavBar from './components/NavBar.js';
import BioSection from './components/BioSection.js';
import LandingPage from './pages/LandingPage.js';
import CourseShowcase from './pages/CourseShowcase.js';
import ResourcePage from './pages/ResourcePage.js';
import ContactUs from './components/ContactUs.js';

function App() {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [product, setProduct] = useState(false);

    const openContactModal = (product) => {
        setIsContactModalOpen(true);
        setProduct(product);
    };

    const closeContactModal = () => {
        setIsContactModalOpen(false);
    };

    return (
        <Router>
            <div className="app-container">
                <NavBar onContactClick={openContactModal} />

                <ContactUs
                    isOpen={isContactModalOpen}
                    onClose={closeContactModal}
                    product={product}
                />

                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<LandingPage onEnrollNow={openContactModal} />} />
                        <Route path="/course-showcase" element={<CourseShowcase />} />
                        <Route path="/resources/:courseSlug" element={<ResourcePage />} />
                    </Routes>
                </main>

                <BioSection />

                <footer className="app-footer">
                    <p>© {new Date().getFullYear()} Adult Literacy and Numeracy. All rights reserved.</p>
                    <p>Empowering Minds, Enriching Futures.</p>
                </footer>
            </div>
        </Router>
    );
}

export default App;
